import amtrust from '@/assets/marketing/carrier-logos/amtrust.png'
import biberk from '@/assets/marketing/carrier-logos/biberk.png'
import chubb from '@/assets/marketing/carrier-logos/chubb.png'
import corgiInsurance from '@/assets/marketing/carrier-logos/corgi-insurance.png'
import coverWhale from '@/assets/marketing/carrier-logos/cover-whale.png'
import ergoNext from '@/assets/marketing/carrier-logos/ergo-next.png'
import geico from '@/assets/marketing/carrier-logos/geico.png'
import greatAmerican from '@/assets/marketing/carrier-logos/great-american.png'
import hanover from '@/assets/marketing/carrier-logos/hanover.png'
import hiscox from '@/assets/marketing/carrier-logos/hiscox.png'
import insurFi from '@/assets/marketing/carrier-logos/insur-fi.png'
import pathpoint from '@/assets/marketing/carrier-logos/pathpoint.png'
import progressive from '@/assets/marketing/carrier-logos/progressive.png'
import rocklake from '@/assets/marketing/carrier-logos/rocklake.png'
import three from '@/assets/marketing/carrier-logos/three.png'

export interface CarrierLogo {
  src: string
  alt: string
}

/**
 * Static carrier-logo manifest. The marketing site read `public/carrier-logos/`
 * at request time via a Next API route; in this SPA the logos are bundled
 * assets, so we list them here (sorted, matching the old dir-listing order).
 */
export const CARRIER_LOGOS: CarrierLogo[] = [
  { src: biberk, alt: 'Biberk' },
  { src: chubb, alt: 'Chubb' },
  { src: corgiInsurance, alt: 'Corgi Insurance' },
  { src: coverWhale, alt: 'Cover Whale' },
  { src: geico, alt: 'Geico' },
  { src: hanover, alt: 'Hanover' },
  { src: progressive, alt: 'Progressive' },
  { src: rocklake, alt: 'Rocklake' },
]

/** Providers shopped for contractor trades (the /insurance/<vertical> pages), which differ from trucking's. */
export const CONTRACTOR_CARRIER_LOGOS: CarrierLogo[] = [
  { src: biberk, alt: 'Biberk' },
  { src: chubb, alt: 'Chubb' },
  { src: corgiInsurance, alt: 'Corgi Insurance' },
  { src: coverWhale, alt: 'Cover Whale' },
  { src: geico, alt: 'Geico' },
  { src: hanover, alt: 'Hanover' },
  { src: amtrust, alt: 'AmTrust' },
  { src: greatAmerican, alt: 'Great American Insurance Group' },
  { src: hiscox, alt: 'Hiscox' },
  { src: insurFi, alt: 'Insur-Fi' },
  { src: ergoNext, alt: 'ERGO NEXT' },
  { src: pathpoint, alt: 'Pathpoint' },
  { src: three, alt: 'THREE by Berkshire Hathaway' },
]
